import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppHeader from "@/components/home/AppHeader";
import WelcomeHeader from "@/components/home/WelcomeHeader";
import ExploreSearch from "@/components/home/ExploreSearch";
import ContinueReading from "@/components/home/ContinueReading";
import RecommendedForYou from "@/components/home/RecommendedForYou";
import TrendingBooks from "@/components/home/TrendingBooks";
import BrowseGenres from "@/components/home/BrowseGenres";
import CuratedLists from "@/components/home/CuratedLists";
import PopularCommunities from "@/components/home/PopularCommunities";
import PeopleToFollow from "@/components/home/PeopleToFollow";
import ActivityFeed from "@/components/home/ActivityFeed";
import CoverClubTeaser from "@/components/home/CoverClubTeaser";
import BookSearchResults from "@/components/books/BookSearchResults";
import { EXPLORE } from "@/constants/testIds";

export default function Explore() {
  const [activeSearchQuery, setActiveSearchQuery] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isFirstVisit = new URLSearchParams(location.search).get("welcome") === "1";

  const dismissWelcome = () => navigate("/app/explore", { replace: true });

  return (
    <div className="relative min-h-screen bg-cream" data-testid={EXPLORE.page}>
      <AppHeader />
      <main className="pb-28 md:pb-20">
        <WelcomeHeader />
        {isFirstVisit && (
          <section className="u-container mt-6" aria-labelledby="first-visit-heading" data-testid="first-visit-welcome">
            <div className="flex flex-col gap-4 rounded-2xl border border-sage/50 bg-sage/15 p-5 shadow-soft sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="u-eyebrow text-sage">Your reading corner is ready</p>
                <h2 id="first-visit-heading" className="mt-1 font-display text-xl font-semibold text-ink">What will you read first?</h2>
                <p className="mt-1 text-sm text-subtle">Search for a book, author, or story that is already on your mind.</p>
              </div>
              <button type="button" onClick={dismissWelcome} className="shrink-0 text-left text-sm font-semibold text-coral hover:text-coral/80 sm:text-right">I’ll explore first</button>
            </div>
          </section>
        )}
        <section className="u-container mt-8">
          <ExploreSearch onViewAllResults={setActiveSearchQuery} focusRequested={isFirstVisit} />
        </section>

        {activeSearchQuery ? (
          <BookSearchResults query={activeSearchQuery} onBack={() => setActiveSearchQuery(null)} />
        ) : (
          <>
            <ContinueReading />
            <RecommendedForYou />
            <TrendingBooks />
            <BrowseGenres />
            <CoverClubTeaser />
            <CuratedLists />
            <PopularCommunities />
            <PeopleToFollow />
            <ActivityFeed />
          </>
        )}
      </main>
    </div>
  );
}
